export default "__VITE_ASSET__B3I5xgth__"